document.addEventListener("DOMContentLoaded", function () {

    const STORAGE_KEY = "saleCountdownEnd";
    const RESET_TIME = 5 * 24 * 60 * 60 * 1000; // 5 days

    function getEndTime() {
        let endTime = localStorage.getItem(STORAGE_KEY);

        if (!endTime || Date.now() >= Number(endTime)) {
            endTime = Date.now() + RESET_TIME;
            localStorage.setItem(STORAGE_KEY, endTime);
        }

        return Number(endTime);
    }

    let endTime = getEndTime();

    function updateCountdown() {
        let timeLeft = endTime - Date.now();

        // Reset to another 5 days when countdown ends
        if (timeLeft <= 0) {
            endTime = Date.now() + RESET_TIME;
            localStorage.setItem(STORAGE_KEY, endTime);
            timeLeft = RESET_TIME;
        }

        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        // If you have a days element
        const daysElement = document.getElementById("days");
        if (daysElement) {
            daysElement.textContent = String(days).padStart(2, "0");
        }

        document.getElementById("hours").textContent = String(hours).padStart(2, "0");
        document.getElementById("minutes").textContent = String(minutes).padStart(2, "0");
        document.getElementById("seconds").textContent = String(seconds).padStart(2, "0");
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);

});